import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";
import modularScaleLib from 'modular-scale';

var generateTypescale = function generateTypescale(breakpoints) {
  var typeScale = {};
  Object.entries(breakpoints).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpointKey = _ref2[0],
        breakpointValue = _ref2[1];

    // Initialize typescale for iterated breakpoint
    typeScale[breakpointKey] = {}; // Initialize modular scale

    var ms = modularScaleLib({
      ratio: breakpointValue.ratio,
      base: breakpointValue.base
    });
    typeScale[breakpointKey] = ms;
  });
  return typeScale;
};

export { generateTypescale };